import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useOrganizacion } from '@/core/providers/OrganizacionProvider'
import { PageHeader } from '@/components/layout'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { PresupuestoForm } from '@/components/presupuestos/PresupuestoForm'
import type { PresupuestoFormValues } from '@/components/presupuestos/PresupuestoForm'
import { useCrearPresupuesto } from '@/hooks/usePresupuestos'
import { toast } from 'sonner'
import type { Json } from '@/types/database'

export function PresupuestoNuevo() {
  const navigate = useNavigate()
  const { user } = useAuth0()
  const { organizacionId } = useOrganizacion()
  const crearPresupuesto = useCrearPresupuesto()

  const handleSubmit = async (data: PresupuestoFormValues & { subtotal: number; total: number }) => {
    if (!organizacionId) {
      toast.error('No se pudo identificar la organización. Recargue la página.')
      return
    }
    try {
      const presupuestoData = {
        numero: 0,
        organizacion_id: organizacionId,
        cliente_nombre: data.cliente_nombre,
        cliente_cuit: data.cliente_cuit,
        cliente_email: data.cliente_email,
        cliente_id: data.cliente_id,
        condiciones_pago: data.condiciones_pago,
        fecha: data.fecha,
        fecha_emision: data.fecha,
        titulo: `Presupuesto para ${data.cliente_nombre}`,
        validez_dias: data.validez_dias,
        items: data.items as unknown as Json,
        subtotal: data.subtotal,
        descuento_porcentaje: data.descuento_porcentaje,
        iva_porcentaje: parseFloat(data.iva_porcentaje) || 0,
        total: data.total,
        notas: data.notas,
        admin_nombre: data.admin_nombre,
        admin_cuit: data.admin_cuit,
        estado: 'borrador',
        created_by: user?.email ?? 'sistema',
      }

      await crearPresupuesto.mutateAsync(presupuestoData)
      toast.success('Presupuesto creado correctamente')
      navigate('/presupuestos')
    } catch {
      // El onError de useCrearPresupuesto muestra el toast, y dice si faltó un permiso.
    }
  }

  const handleCancel = () => {
    navigate('/presupuestos')
  }

  return (
    <div className="flex flex-col h-full">
      <PageHeader
        title="Nuevo Presupuesto"
        description="Crear un nuevo presupuesto para un cliente"
      />

      <main className="flex-1 p-6">
        {/* Breadcrumb / Back button */}
        <div className="mb-6">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCancel}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver a Presupuestos
          </Button>
        </div>

        {/* Formulario */}
        <PresupuestoForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={crearPresupuesto.isPending}
        />
      </main>
    </div>
  )
}
